import clsx from 'clsx';
import React from 'react';
import { theme } from '../../utils';
import styles from './Banner.module.scss';
export const Banner = ({ header, title, content, imageUrl, mobileImageUrl = null, variant = 'vertical', palette = 'primary', typo = 'normal', footer = null, rounded = false, fullWidthOnMobile = false, gutterBottom = false, extraContent = null, animation = null, imagePlacement = 'right', mobilePadding = 'true', }) => {
    return (<div className={clsx(styles.ownersBanner, styles[variant], styles[palette], styles[typo], styles[imagePlacement], rounded && styles.rounded, fullWidthOnMobile && styles.mobileFullWidth, gutterBottom && styles.gutterBottom)}>
      {header}
      {imageUrl && variant === 'vertical' && (
        // TODO check if fragment can be replaced with another element
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {mobileImageUrl ? (<picture>
              <source media={`(min-width:${theme.constants.md})`} srcSet={imageUrl}/>
              <source media={`(min-width:${theme.constants.xs})`} srcSet={mobileImageUrl}/>
              <img className={styles.ownersBannerImage} src={imageUrl} alt={title}/>
            </picture>) : (<img className={styles.ownersBannerImage} src={imageUrl} alt={title}/>)}
        </>)}
      {imageUrl && variant === 'horizontal' && (<div className={styles.ownersBannerImage}>
          {mobileImageUrl ? (<picture>
              <source media={`(min-width:${theme.constants.md})`} srcSet={imageUrl}/>
              <source media={`(min-width:${theme.constants.xs})`} srcSet={mobileImageUrl}/>
              <img className={styles.ownersBannerImage} src={imageUrl} alt={title}/>
            </picture>) : (<img className={styles.ownersBannerImage} src={imageUrl} alt={title}/>)}
        </div>)}
      <div className={clsx(styles.ownersBannerContentWrapper, mobilePadding && styles.ownersBannerExtraPaddedContentWrapper)}>
        {animation}
        <div className={styles.ownersBannerContent}>
          <div>
            {title && <h2 className={`owners-heading-${typo === 'main' ? '1' : '3'}`}>{title}</h2>}
            <div className={clsx(styles.content, 'owners-body')}>{content}</div>
            {footer && <div className={styles.ownersBannerFooter}>{footer}</div>}
          </div>
          {extraContent && <div className={styles.ownersBannerExtraContent}>{extraContent}</div>}
        </div>
      </div>
    </div>);
};
